import { getSkeletonStyles } from './SkeletonStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { SkeletonBackgroundColor } from './types/backgroundColor.js';
import { SkeletonVariant } from './types/variant.js';

const Skeleton = props => {
  const {
    animation,
    backgroundColor = SkeletonBackgroundColor.LIGHT,
    variant = SkeletonVariant.TEXT,
    width,
    height,
    ...rest
  } = props;
  return jsx("span", {
    ...rest,
    css: getSkeletonStyles(backgroundColor, variant, animation, height, width)
  });
};

export { Skeleton };
//# sourceMappingURL=Skeleton.js.map
